import { render, staticRenderFns } from "./AssignStudent.vue?vue&type=template&id=5ed10caa&scoped=true"
import script from "./AssignStudent.vue?vue&type=script&lang=js"
export * from "./AssignStudent.vue?vue&type=script&lang=js"
import style0 from "./AssignStudent.vue?vue&type=style&index=0&id=5ed10caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed10caa",
  null
  
)

export default component.exports